import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import UserServicesFactory from '../../user/Services/factory.js'
import {GetAdContactPhoneAdsError} from '../Errors/GetAdContactPhoneAdsError.js'
import AdsRepositoriesFactory from '../Repositories/factory.js'

class GetAdContactPhoneAdsUseCase extends UseCase {
  #repository
  #getCurrentUserService

  #handleError(error) {
    if (GetAdContactPhoneAdsError.isGetAdContactPhoneAdsError({error})) return Promise.reject(error)
    return Promise.reject(GetAdContactPhoneAdsError.createGenericError({cause: error}))
  }

  constructor({repository, getCurrentUserService}) {
    super()
    this.#repository = repository
    this.#getCurrentUserService = getCurrentUserService
  }

  static create({config}) {
    return new GetAdContactPhoneAdsUseCase({
      repository: AdsRepositoriesFactory.httpAdsRepository({config}),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({config})
    })
  }

  @tracer({metric: 'GetAdContactPhoneAdsUseCase#execute'})
  @AsyncInlineError()
  async execute({adId, isPrivate = false} = {}) {
    try {
      if (!adId) throw GetAdContactPhoneAdsError.createInvalidAdIdError()

      if (isPrivate) {
        const currentUser = await this.#getCurrentUserService.execute()
        if (!currentUser) throw GetAdContactPhoneAdsError.createUnauthorizedError()
      }

      const [error, response] = await this.#repository.getAdContactPhone({adId, isPrivate})
      return error ? this.#handleError(error) : response
    } catch (error) {
      return this.#handleError(error)
    }
  }
}

export const factory = GetAdContactPhoneAdsUseCase.create
